import { render, staticRenderFns } from "./HeroVideo.vue?vue&type=template&id=3d55d2b4&scoped=true"
import script from "./HeroVideo.vue?vue&type=script&lang=js"
export * from "./HeroVideo.vue?vue&type=script&lang=js"
import style0 from "./HeroVideo.vue?vue&type=style&index=0&id=3d55d2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d55d2b4",
  null
  
)

export default component.exports